import React from 'react';
import { MasterChannel } from '../MasterChannel';
import { MasterChannelLink } from '../MasterChannelLink';
import ChannelList from '../../channels.json';
import { Channel } from '../Channel';
import { ChannelLink } from '../ChannelLink';

class ChannelSelector extends React.Component {

  constructor(props) {

    super(props)

    this.state = {showRegionSelector: false};

    this.handler = this.handler.bind(this)
  }

  handler(someValue) {
    
    this.setState(state => ({
      showRegionSelector: !state.showRegionSelector
    }))
  }


  renderChannel(i) {
    
    let activeChannelCode = window.location.search.split('=')[1];
    if (i === 'radio2') {
      // Do Radio 2 stuff here
      if ((typeof activeChannelCode !== 'undefined') && (activeChannelCode.charAt(0) === '2')) {
        return <MasterChannel key={i} channelCode={20} channelId={i} />;
      } else {
        return <MasterChannelLink handler={this.handler} key={i} channelCode={20} channelId={i} />;
      }
    } else {
      if (ChannelList[i].id === activeChannelCode) {
        return <Channel key={i} channelCode={ChannelList[i].id} channelId={i} />;
      } else {
        return <ChannelLink key={i} channelCode={ChannelList[i].id} channelId={i} />;
      }
    }
  }

  render() {
    let channels = [];

    if (!this.state.showRegionSelector) {
      // standaard flow
      let r2done = false;

      for (let i = 0; i < ChannelList.length; i++) {
        if (ChannelList[i].id.charAt(0) === '2') {
          // Radio 2 regio gevonden
          if (!r2done) {
            // Radio 2 staat nog niet in de lijst en moet dus toegevoegd worden
            channels.push(
              this.renderChannel('radio2')
            );
            // Na het toevoegen zetten we de controle var op true
            r2done = true;
          }
        } else {
          channels.push(
            this.renderChannel(i)
          );
        }
      }
    } else {
      // Radio 2 regio overzicht

      for (let i = 0; i < ChannelList.length; i++) {
        if (ChannelList[i].id.charAt(0) === '2') {
          // Radio 2 regio gevonden
          channels.push(
            this.renderChannel(i)
          );
        }
      }
    }

    return (
      <>
        <div className="channel-list">
          {channels}
        </div>
        <div className="region-selector">
            { this.state.showRegionSelector ? (
                <button onClick={this.handler}>Toon alle zenders</button>
            ) : (
              null
            )}
        </div>
      </>
    );
  }
}

export default ChannelSelector;